import { get } from 'lodash';

export const getUserInfo = appState => {
  let hasOrders = !!get(appState, 'orders', null);
  let licensePlates = get(appState, 'licensePlates', []);
  let parkingRecords = get(appState, 'parkingRecord', []);

  return {
    hasLicensePlates: licensePlates.length !== 0,
    hasPayments: !!get(appState, 'me.currentCreditCard', null),
    hasStreetParkingAutoPay: !!get(appState, 'me.enableOnStreetParkingAutoPay'),
    hasRefuelingOrders: hasOrders && get(appState, 'orders.refueling', []).length !== 0,
    hasParkingOrders: hasOrders && get(appState, 'orders.parking', []).length !== 0,
    hasParkingRecords: parkingRecords.length !== 0,
    maxVehicleCounts: get(appState, 'me.maxVehicleCount', 3),
  };
};
